import React from 'react';
import './styles.scss'

const HTMLRenderer = ({ htmlString }) => {
  return <div className='htmlRenderer' dangerouslySetInnerHTML={{ __html: htmlString }} />;
};

export default HTMLRenderer;